import { createBrowserRouter } from "react-router-dom"

import { authRoutes } from "~/features/auth/routes"
import { mainRoutes } from "~/router/routes/main/mainRoutes"
import NotFound from "~/router/routes/NotFound"

export const router = createBrowserRouter([
  ...mainRoutes,
  ...authRoutes,
  {
    path: "*",
    element: <NotFound />,
  },
])
